export default "__VITE_ASSET__ls2S475G__"